/* Ya Qalbi theme behaviour. Vanilla, no dependencies. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; };

  /* ---------------- Header height ---------------- */
  /* Sticky filter bars, sidebars and tables of contents sit under the header.
     Its height changes by breakpoint (the tablet row of pills adds 48px), so
     measure it instead of hard-coding it. Observe the section wrapper: the
     header inside it is replaced whenever the cart count re-renders. */
  var headerWrap = document.getElementById('shopify-section-yq-header');
  function setHeaderHeight() {
    if (headerWrap) document.documentElement.style.setProperty('--yq-header-h', headerWrap.offsetHeight + 'px');
  }
  setHeaderHeight();
  if (headerWrap && window.ResizeObserver) new ResizeObserver(setHeaderHeight).observe(headerWrap);
  else window.addEventListener('resize', setHeaderHeight);

  /* ---------------- Overlays ---------------- */
  /* Cart, search, menu, saved, filters and zoom are mutually exclusive and
     share one scrim. */
  var OPEN = null;
  function panels() { return $$('[data-yq-panel]'); }

  function closeOverlay() {
    var scrim = $('[data-yq-scrim]');
    panels().forEach(function (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
    if (scrim) scrim.classList.remove('is-open');
    document.body.classList.remove('yq-locked');
    if (OPEN && OPEN.opener && OPEN.opener.focus) OPEN.opener.focus();
    OPEN = null;
  }

  function openOverlay(name, opener) {
    var panel = $('[data-yq-panel="' + name + '"]');
    if (!panel) return;
    if (OPEN && OPEN.name === name) { closeOverlay(); return; }
    panels().forEach(function (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
    var scrim = $('[data-yq-scrim]');
    if (scrim) scrim.classList.add('is-open');
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('yq-locked');
    OPEN = { name: name, opener: opener || null };
    if (name === 'saved') renderSaved();
    if (name === 'search') {
      setTimeout(function () { var i = $('[data-yq-search-input]'); if (i) i.focus(); }, 120);
    } else {
      var f = panel.querySelector('button, a, input');
      if (f) f.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-yq-open]');
    if (open) { e.preventDefault(); openOverlay(open.getAttribute('data-yq-open'), open); return; }
    if (e.target.closest('[data-yq-close]') || e.target.hasAttribute('data-yq-scrim') || e.target.hasAttribute('data-yq-zoom-bg')) { closeOverlay(); return; }
    var mega = e.target.closest('[data-yq-mega-toggle]');
    if (mega) {
      e.preventDefault();
      var m = $('[data-yq-mega]');
      if (m) { m.classList.toggle('is-open'); mega.setAttribute('aria-expanded', m.classList.contains('is-open')); }
      return;
    }
    if (!e.target.closest('[data-yq-mega]')) {
      var om = $('[data-yq-mega].is-open');
      if (om) { om.classList.remove('is-open'); var t = $('[data-yq-mega-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (OPEN) { closeOverlay(); return; }
      var m = $('[data-yq-mega].is-open');
      if (m) m.classList.remove('is-open');
      return;
    }
    if (OPEN && OPEN.name === 'zoom' && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      stepZoom(e.key === 'ArrowRight' ? 1 : -1);
      return;
    }
    if (e.key !== 'Tab' || !OPEN) return;
    /* Focus trap while an overlay is open. */
    var panel = $('[data-yq-panel="' + OPEN.name + '"]');
    if (!panel) return;
    var f = $$('a[href],button:not([disabled]),input:not([disabled]),textarea,select,[tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------------- Section rendering ---------------- */
  function refreshSections(ids, after) {
    fetch(root() + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        ids.forEach(function (id) {
          if (!data[id]) return;
          var target = document.getElementById('shopify-section-' + id);
          if (!target) return;
          var doc = new DOMParser().parseFromString(data[id], 'text/html');
          var fresh = doc.getElementById('shopify-section-' + id);
          if (fresh) target.innerHTML = fresh.innerHTML;
        });
        paintSaved();
        if (after) after();
      })
      .catch(function () { if (after) after(); });
  }

  /* ---------------- Cart ---------------- */
  function announce(msg) { var live = $('[data-yq-live]'); if (live) live.textContent = msg; }

  /* Cart errors (stock limits, a dropped connection) must be seen, not only
     read out: the live region is visually hidden. */
  var noticeTimer;
  function notify(msg) {
    announce(msg);
    var n = $('[data-yq-notice]');
    if (!n) {
      n = document.createElement('div');
      n.setAttribute('data-yq-notice', '');
      n.setAttribute('aria-hidden', 'true');
      n.style.cssText = 'position:fixed;left:50%;bottom:calc(92px + env(safe-area-inset-bottom));transform:translateX(-50%);z-index:70;' +
        'width:max-content;max-width:calc(100vw - 32px);padding:12px 18px;border-radius:var(--yq-r-pill);background:var(--yq-ink);' +
        'color:var(--yq-bg-card);font:500 14px/1.4 var(--yq-sans);text-align:center;box-shadow:var(--yq-shadow-float)';
      document.body.appendChild(n);
    }
    n.textContent = msg;
    n.hidden = false;
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () { n.hidden = true; }, 5000);
  }

  function addToCart(variantId, qty, btn) {
    /* Busy or sold out: a second tap must not add the piece twice. */
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    if (btn) btn.setAttribute('aria-disabled', 'true');
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (btn) btn.removeAttribute('aria-disabled');
        if (!res.ok) { notify(res.body.description || res.body.message || 'Could not add to bag.'); return; }
        refreshSections(['yq-cart-drawer', 'yq-header'], function () { openOverlay('cart'); });
      })
      .catch(function () { if (btn) btn.removeAttribute('aria-disabled'); notify('Could not add to bag. Check your connection and try again.'); });
  }

  function changeLine(key, quantity) {
    fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (b) { notify(b.description || b.message || 'Could not update your bag.'); });
      })
      .catch(function () { notify('Could not update your bag. Check your connection and try again.'); })
      .then(function () { refreshSections(['yq-cart-drawer', 'yq-header']); });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-yq-add]');
    if (add) { e.preventDefault(); addToCart(add.getAttribute('data-yq-add'), Number(add.getAttribute('data-qty') || 1), add); return; }

    var line = e.target.closest('[data-yq-line]');
    if (line) { e.preventDefault(); changeLine(line.getAttribute('data-yq-line'), Number(line.getAttribute('data-qty'))); return; }

    var step = e.target.closest('[data-yq-step]');
    if (step) {
      e.preventDefault();
      var input = step.parentNode.querySelector('input');
      if (!input) return;
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.getAttribute('data-yq-step')));
      input.value = next;
      $$('[data-yq-buy],[data-yq-barbuy]').forEach(function (b) { b.setAttribute('data-qty', next); });
    }
  });

  /* Gift toggle and note -> cart attributes. */
  function updateAttributes(attrs) {
    fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }
  document.addEventListener('change', function (e) {
    var gift = e.target.closest('[data-yq-gift]');
    if (!gift) return;
    var note = $('[data-yq-giftnote]');
    if (note) note.hidden = !gift.checked;
    updateAttributes({ gift: gift.checked ? 'yes' : 'no' });
  });
  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-yq-giftnote] textarea');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { updateAttributes({ gift_note: note.value }); }, 600);
  });

  /* ---------------- Checkout: always through Razorpay first ---------------- */
  /* Razorpay Magic Checkout collects the phone and address and checks cash on
     delivery, then opens Shopify's payment page prefilled, where the customer
     pays through Razorpay or chooses cash on delivery. Its script takes clicks
     on [name="checkout"] in the capture phase, so a click that reaches this
     handler is one it did not take:
     - its script has not started yet (it sets __init_magic_x__ when it does):
       wait for it instead of skipping the Razorpay step;
     - it has started: the click is Razorpay handing over on purpose (empty
       cart, or its native-click mode), so let it through untouched.
     Without the Razorpay app embed there is nothing to wait for. If Razorpay
     never loads, offer the plain checkout or WhatsApp rather than a dead end. */
  var coWait = 0;
  function coBusy(btn, on) {
    btn.style.opacity = on ? '.6' : '';
    btn.style.cursor = on ? 'progress' : '';
    if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  }
  function checkoutUnavailable(btn) {
    var anchor = btn.closest('form') || btn;
    var msg = anchor.parentNode.querySelector('[data-yq-co-msg]');
    if (!msg) {
      msg = document.createElement('p');
      msg.setAttribute('data-yq-co-msg', '');
      msg.setAttribute('role', 'alert');
      msg.className = 'yq-pin__msg is-err';
      anchor.parentNode.insertBefore(msg, anchor.nextSibling);
    }
    msg.innerHTML = 'Quick checkout did not load. ' +
      '<a href="' + root() + 'checkout" style="text-decoration:underline">Continue to checkout</a> or ' +
      '<a href="https://wa.me/918003450708?text=' + encodeURIComponent('Hi! I would like to complete my order.') +
      '" target="_blank" rel="noopener" style="text-decoration:underline">order on WhatsApp</a>.';
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[name="checkout"]');
    if (!btn || window.__init_magic_x__ || !document.getElementById('RazorpayMagicSopcConfig')) return;
    e.preventDefault();
    if (e.isTrusted && coWait) return; /* already waiting for Razorpay */
    if (coWait >= 12) { coWait = 0; coBusy(btn, false); checkoutUnavailable(btn); return; }
    coWait++;
    coBusy(btn, true);
    setTimeout(function () {
      var target = document.contains(btn) ? btn : $('[name="checkout"]');
      if (!target) { coWait = 0; return; }
      if (window.__init_magic_x__) { coWait = 0; coBusy(target, false); }
      target.click();
    }, 500);
  });

  /* ---------------- Sliders (hero, gallery) ---------------- */
  function initSlider(el) {
    var track = $('[data-yq-track]', el);
    if (!track) return;
    var dots = $$('[data-yq-dot]', el);
    var counter = $('[data-yq-counter]', el);
    var total = track.children.length;
    function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function sync() {
      var i = index();
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + total;
    }
    track.addEventListener('scroll', function () {
      if (el._raf) return;
      el._raf = requestAnimationFrame(function () { el._raf = null; sync(); });
    }, { passive: true });
    function go(i) { track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    var prev = $('[data-yq-prev]', el), next = $('[data-yq-next]', el);
    if (prev) prev.addEventListener('click', function () { go(index() === 0 ? total - 1 : index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() >= total - 1 ? 0 : index() + 1); });
    sync();
  }
  $$('[data-yq-slider]').forEach(initSlider);

  /* ---------------- Image zoom ---------------- */
  /* Every content image (product gallery, article photos) opens large on
     click; navigational images are links instead. */
  var ZOOM = { list: [], i: 0 };
  function bigSrc(img) {
    var src = img.currentSrc || img.src || '';
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=2000') : src;
  }
  function showZoom() {
    var target = $('[data-yq-zoom-img]');
    var img = ZOOM.list[ZOOM.i];
    if (!target || !img) return;
    target.src = bigSrc(img);
    target.alt = img.alt || '';
    var count = $('[data-yq-zoom-count]');
    if (count) count.textContent = ZOOM.list.length > 1 ? (ZOOM.i + 1) + ' / ' + ZOOM.list.length : '';
    $$('[data-yq-zoom-step]').forEach(function (b) { b.hidden = ZOOM.list.length < 2; });
  }
  function stepZoom(d) {
    if (ZOOM.list.length < 2) return;
    ZOOM.i = (ZOOM.i + d + ZOOM.list.length) % ZOOM.list.length;
    showZoom();
  }
  document.addEventListener('click', function (e) {
    var st = e.target.closest('[data-yq-zoom-step]');
    if (st) { e.preventDefault(); stepZoom(Number(st.getAttribute('data-yq-zoom-step'))); return; }
    var img = e.target.closest('[data-yq-zoom] img');
    if (!img || img.closest('a')) return;
    var group = img.closest('[data-yq-zoom]');
    ZOOM.list = $$('img', group).filter(function (x) { return !x.closest('a'); });
    ZOOM.i = Math.max(0, ZOOM.list.indexOf(img));
    showZoom();
    openOverlay('zoom', img);
  });

  /* ---------------- PDP: one accordion open at a time ---------------- */
  $$('[data-yq-acc-group] details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      $$('[data-yq-acc-group] details').forEach(function (o) { if (o !== d) o.open = false; });
    });
  });

  /* ---------------- Pincode checker ---------------- */
  /* Only the format is checked here. Whether the courier delivers to a
     pincode, and so whether cash on delivery is offered, is decided at
     checkout for the real address, so this must not promise it. */
  var pinForm = $('[data-yq-pin]');
  if (pinForm) {
    pinForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = $('input', pinForm);
      var msg = $('[data-yq-pin-msg]');
      var v = (input.value || '').trim();
      if (!/^[1-9]\d{5}$/.test(v)) {
        msg.textContent = 'Enter a valid 6-digit pincode.';
        msg.className = 'yq-pin__msg is-err';
        return;
      }
      msg.textContent = 'Leaves us within 2 working days, then usually 4–5 working days to metro cities and 7 to the rest of India. Checkout shows whether cash on delivery is available at your address.';
      msg.className = 'yq-pin__msg is-ok';
    });
  }

  /* ---------------- Money ---------------- */
  function money(cents) {
    var el = $('[data-money]');
    var fmt = (el && el.getAttribute('data-money')) || 'Rs. {{amount_no_decimals}}';
    var whole = Math.round(cents / 100).toLocaleString('en-IN');
    var dec = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, whole).replace(/\{\{\s*amount[^}]*\}\}/, cents % 100 ? dec : whole);
  }

  /* ---------------- Saved (wishlist) ---------------- */
  var SAVED = 'yq_saved';
  function saved() { try { return JSON.parse(localStorage.getItem(SAVED) || '[]'); } catch (e) { return []; } }
  function setSaved(list) { try { localStorage.setItem(SAVED, JSON.stringify(list)); } catch (err) {} }
  function paintSaved() {
    var list = saved();
    $$('[data-yq-save]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-yq-save')) > -1;
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on);
      var i = b.querySelector('i');
      if (i) i.className = on ? 'ri-heart-fill' : 'ri-heart-line';
    });
    $$('[data-yq-saved-count]').forEach(function (c) { c.textContent = list.length ? '(' + list.length + ')' : ''; });
  }
  function productCache(h) {
    productCache.map = productCache.map || {};
    if (!productCache.map[h]) {
      productCache.map[h] = fetch(root() + 'products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache.map[h];
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function renderSaved() {
    var list = saved();
    var mount = $('[data-yq-saved-list]');
    var empty = $('[data-yq-saved-empty]');
    if (!mount) return;
    paintSaved();
    if (!list.length) { mount.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    Promise.all(list.map(productCache)).then(function (items) {
      var live = items.filter(Boolean);
      /* Drop handles for products that no longer exist, so nothing dead lingers. */
      if (live.length !== list.length) setSaved(live.map(function (p) { return p.handle; }));
      if (!live.length) { mount.innerHTML = ''; if (empty) empty.hidden = false; paintSaved(); return; }
      mount.innerHTML = live.map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        /* Several colours or sizes: choose on the product page, never add a default. */
        var multi = (p.variants || []).length > 1;
        var url = root() + 'products/' + p.handle;
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=260' : '';
        var btnStyle = 'height:38px;padding:0 16px;font-size:13px';
        return '<div class="yq-li">' +
          '<a href="' + url + '">' + (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<div><a href="' + url + '" style="font-size:14px;font-weight:500">' + esc(p.title) + '</a>' +
          '<div class="yq-num" style="font-size:14px;font-weight:600;margin-top:6px">' + money(p.price) + '</div>' +
          '<div style="display:flex;align-items:center;gap:14px;margin-top:10px">' +
          (!v ? '<span class="yq-meta">Sold out</span>'
             : multi ? '<a class="yq-btn yq-btn--primary" style="' + btnStyle + '" href="' + url + '">Choose options</a>'
             : '<button type="button" class="yq-btn yq-btn--primary" style="' + btnStyle + '" data-yq-add="' + v.id + '">Add to bag</button>') +
          '<button type="button" class="yq-meta" style="border:0;background:none;text-decoration:underline" data-yq-save="' + esc(p.handle) + '">Remove</button>' +
          '</div></div></div>';
      }).join('');
      paintSaved();
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-yq-save]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-yq-save');
    var list = saved();
    var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    setSaved(list);
    paintSaved();
    if (OPEN && OPEN.name === 'saved') renderSaved();
  });
  paintSaved();

  /* ---------------- Recently viewed ---------------- */
  var RV = 'yq_recent';
  var current = document.body.getAttribute('data-yq-product');
  if (current) {
    try {
      var r = JSON.parse(localStorage.getItem(RV) || '[]').filter(function (h) { return h !== current; });
      r.unshift(current);
      localStorage.setItem(RV, JSON.stringify(r.slice(0, 12)));
    } catch (e) {}
  }
  var rvMount = $('[data-yq-recent]');
  if (rvMount) {
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem(RV) || '[]'); } catch (e) {}
    handles = handles.filter(function (h) { return h !== current; }).slice(0, 8);
    if (!handles.length) { rvMount.hidden = true; }
    else {
      var target = $('[data-yq-recent-track]', rvMount);
      Promise.all(handles.map(productCache)).then(function (items) {
        var html = items.filter(Boolean).map(function (p) {
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
          var url = root() + 'products/' + p.handle;
          return '<div class="yq-pc" style="width:160px"><div class="yq-pc__img"><a class="yq-pc__imglink" href="' + url + '">' +
            (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a></div>' +
            '<div class="yq-pc__body"><a class="yq-pc__name" href="' + url + '">' + esc(p.title) + '</a>' +
            '<div class="yq-pc__prices"><span class="yq-pc__price yq-num">' + money(p.price) + '</span></div></div></div>';
        }).join('');
        if (html) { target.innerHTML = html; } else { rvMount.hidden = true; }
      });
    }
  }

  /* ---------------- Article / document: reading progress, TOC ---------------- */
  var body = $('[data-yq-article-body]');
  if (body) {
    var heads = $$('h2', body);
    heads.forEach(function (h, i) { if (!h.id) h.id = 'yq-s-' + (i + 1); });

    var tocLists = $$('[data-yq-toc]');
    tocLists.forEach(function (l) {
      if (!heads.length) {
        /* No sections to list: remove the empty contents box rather than leave it. */
        var box = l.closest('.yq-toc, .yq-tocbar, .yq-doc__toc');
        if (box) box.hidden = true;
        return;
      }
      l.innerHTML = heads.map(function (h) { return '<li><a href="#' + h.id + '" data-yq-toclink="' + h.id + '">' + esc(h.textContent) + '</a></li>'; }).join('');
    });

    var bar = $('[data-yq-readbar]');
    var pct = $('[data-yq-readpct]');
    var headerBar = $('[data-yq-progress]');
    var label = $('[data-yq-toc-current]');
    var minutes = Number(body.getAttribute('data-minutes') || 0);
    var raf = null;
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var hhh = headerWrap ? headerWrap.offsetHeight : 92;
        var r = body.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, (hhh + 60 - r.top) / Math.max(1, r.height - window.innerHeight + hhh + 60)));
        var bar2 = $('[data-yq-progress]');
        if (bar2) bar2.style.width = (p * 100).toFixed(1) + '%';
        if (bar) bar.style.width = (p * 100).toFixed(1) + '%';
        if (pct && minutes) pct.textContent = Math.round(p * 100) + '% read · ' + Math.max(0, Math.ceil(minutes * (1 - p))) + ' min left';
        var active = heads.length ? heads[0] : null;
        heads.forEach(function (h) { if (h.getBoundingClientRect().top < hhh + 120) active = h; });
        if (active) {
          $$('[data-yq-toclink]').forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-yq-toclink') === active.id); });
          if (label) label.textContent = active.textContent;
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Long tables get a scroll container so they never widen the column. */
    $$('table', body).forEach(function (t) {
      if (t.parentNode.classList.contains('yq-tablewrap')) return;
      var w = document.createElement('div');
      w.className = 'yq-tablewrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
  }

  /* Copy link */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-yq-copy]');
    if (!c) return;
    e.preventDefault();
    navigator.clipboard.writeText(window.location.href).then(function () {
      var old = c.innerHTML;
      c.innerHTML = '<i class="ri-check-line"></i> Copied';
      setTimeout(function () { c.innerHTML = old; }, 1800);
    });
  });

  /* ---------------- FAQ search ---------------- */
  var faqSearch = $('[data-yq-faq-search]');
  if (faqSearch) {
    faqSearch.addEventListener('input', function () {
      var q = faqSearch.value.trim().toLowerCase();
      var anyVisible = false;
      $$('[data-yq-faq-item]').forEach(function (d) {
        var hit = !q || d.textContent.toLowerCase().indexOf(q) > -1;
        d.hidden = !hit;
        if (hit) anyVisible = true;
        d.open = !!q && hit;
      });
      $$('[data-yq-faq-group]').forEach(function (g) {
        g.hidden = !$$('[data-yq-faq-item]', g).some(function (d) { return !d.hidden; });
      });
      var none = $('[data-yq-faq-none]');
      if (none) none.hidden = anyVisible;
    });
  }

  /* ---------------- Countdown (limited edition next drop) ---------------- */
  var count = $('[data-yq-countdown]');
  if (count) {
    var at = Date.parse(count.getAttribute('data-yq-countdown'));
    var tick = function () {
      if (isNaN(at)) { count.hidden = true; return; }
      var ms = Math.max(0, at - Date.now());
      var set = function (k, v) { var el = $('[data-yq-cd="' + k + '"]', count); if (el) el.textContent = v; };
      set('d', Math.floor(ms / 86400000)); set('h', Math.floor(ms / 3600000) % 24); set('m', Math.floor(ms / 60000) % 60);
    };
    tick();
    setInterval(tick, 30000);
  }

  /* ---------------- Purchase toast ---------------- */
  /* Real order data only: the section renders nothing when there is none. */
  var toast = $('[data-yq-toast]');
  if (toast) {
    setTimeout(function () { if (!OPEN) toast.classList.add('is-on'); }, 2500);
    setTimeout(function () { toast.classList.remove('is-on'); }, 11500);
    var dismiss = $('[data-yq-toast-close]', toast);
    if (dismiss) dismiss.addEventListener('click', function () { toast.classList.remove('is-on'); });
  }

  /* ---------------- Collection: load more ---------------- */
  var more = $('[data-yq-loadmore]');
  if (more) {
    more.addEventListener('click', function () {
      var url = more.getAttribute('data-url');
      if (!url) return;
      more.setAttribute('aria-disabled', 'true');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('[data-yq-grid]');
          var grid = $('[data-yq-grid]');
          if (incoming && grid) {
            Array.prototype.forEach.call(incoming.children, function (c) {
              if (!c.classList.contains('yq-editorial')) grid.appendChild(c.cloneNode(true));
            });
          }
          var nextBtn = doc.querySelector('[data-yq-loadmore]');
          if (nextBtn && nextBtn.getAttribute('data-url')) {
            more.setAttribute('data-url', nextBtn.getAttribute('data-url'));
            more.removeAttribute('aria-disabled');
          } else {
            more.hidden = true;
          }
          var shown = doc.querySelector('[data-yq-shown]');
          var here = $('[data-yq-shown]');
          if (shown && here) here.innerHTML = shown.innerHTML;
          var line = doc.querySelector('.yq-pager__line i');
          var hereLine = $('.yq-pager__line i');
          if (line && hereLine) hereLine.style.width = line.style.width;
          paintSaved();
        })
        .catch(function () { more.removeAttribute('aria-disabled'); });
    });
  }

  /* ---------------- Predictive search ---------------- */
  var si = $('[data-yq-search-input]');
  if (si) {
    var t;
    si.addEventListener('input', function () {
      clearTimeout(t);
      var q = si.value.trim();
      var idle = $('[data-yq-search-idle]');
      var out = $('[data-yq-search-results]');
      if (!q) { if (idle) idle.hidden = false; if (out) out.innerHTML = ''; return; }
      if (idle) idle.hidden = true;
      t = setTimeout(function () {
        fetch(root() + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) {
              out.innerHTML = '<div class="yq-empty"><p>Nothing matches yet. Send us what you’re looking for.</p>' +
                '<a class="yq-btn yq-btn--wa" href="https://wa.me/918003450708?text=' +
                encodeURIComponent('Hi! I’m looking for: ' + q) + '" target="_blank" rel="noopener"><i class="ri-whatsapp-line"></i>Ask on WhatsApp</a></div>';
              return;
            }
            out.innerHTML = '<div class="yq-between" style="margin:0 0 14px"><p class="yq-meta" style="margin:0">' + items.length + ' results for “' + esc(q) + '”</p>' +
              '<a class="yq-meta" style="text-decoration:underline" href="' + root() + 'search?q=' + encodeURIComponent(q) + '&type=product">See all</a></div><div class="yq-grid">' +
              items.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
                return '<div class="yq-pc"><div class="yq-pc__img"><a class="yq-pc__imglink" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
                  '</a></div><div class="yq-pc__body"><a class="yq-pc__name" href="' + p.url + '">' + esc(p.title) + '</a>' +
                  '<div class="yq-pc__prices"><span class="yq-pc__price yq-num">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></div></div></div>';
              }).join('') + '</div>';
          });
      }, 220);
    });
  }
})();
